var __jsx = React.createElement;
import React from "react";
var XshareSVG = function XshareSVG() {
  return /*#__PURE__*/React.createElement("svg", {
    className: "XshareSVG",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2153_161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.7456 0 0 10.7456 0 24C0 37.2544 10.7456 48 24 48C37.2544 48 48 37.2544 48 24C48 10.7456 37.2544 0 24 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.624 21.8281L36.8981 9.88525H34.4635L25.5424 20.2551L18.4173 9.88525H10.1992L20.9739 25.5662L10.1992 38.0901H12.634L22.0548 27.1392L29.5795 38.0901H37.7976L26.6234 21.8281H26.624ZM13.5113 11.7181H17.2509L34.4646 36.3406H30.7249L13.5113 11.7181Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2153_161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "48",
    height: "48",
    fill: "white"
  }))));
};
export default XshareSVG;